var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaseScene(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 194,
    viewBox: "0 0 344 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9141C0 9.46134 9.30062 1.4469 19.6492 2.91921C53.2011 7.69273 122.688 16.6433 172 16.6433C221.312 16.6433 290.799 7.69272 324.351 2.91921C334.699 1.4469 344 9.46134 344 19.9141V174.086C344 184.539 334.699 192.553 324.351 191.081C290.799 186.307 221.312 177.357 172 177.357C122.688 177.357 53.2011 186.307 19.6492 191.081C9.30059 192.553 0 184.539 0 174.086V19.9141Z",
    fill: "url(#paint0_linear_807_46216)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_807_46216",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 344,
    height: 190
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9141C0 9.46134 9.30062 1.4469 19.6492 2.91921C53.2011 7.69273 122.688 16.6433 172 16.6433C221.312 16.6433 290.799 7.69272 324.351 2.91921C334.699 1.4469 344 9.46134 344 19.9141V174.086C344 184.539 334.699 192.553 324.351 191.081C290.799 186.307 221.312 177.357 172 177.357C122.688 177.357 53.2011 186.307 19.6492 191.081C9.30059 192.553 0 184.539 0 174.086V19.9141Z",
    fill: "url(#paint1_linear_807_46216)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_807_46216)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.25,
    y1: 1,
    x2: 8.24999,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 18.8501,
    y1: 1,
    x2: 18.8501,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 29.4502,
    y1: 1,
    x2: 29.4502,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 42.4502,
    y1: 1,
    x2: 42.4502,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 55.4502,
    y1: 1,
    x2: 55.4502,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 68.4502,
    y1: 1,
    x2: 68.4502,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 79.0498,
    y1: 1,
    x2: 79.0498,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 90.0498,
    y1: 1,
    x2: 90.0498,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 101.05,
    y1: 1,
    x2: 101.05,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 112.05,
    y1: 1,
    x2: 112.05,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 122.65,
    y1: 1,
    x2: 122.65,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 131.65,
    y1: 1,
    x2: 131.65,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 140.65,
    y1: 1,
    x2: 140.65,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 149.65,
    y1: 1,
    x2: 149.65,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 160.25,
    y1: 1,
    x2: 160.25,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 168.25,
    y1: 1,
    x2: 168.25,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 176.25,
    y1: 1,
    x2: 176.25,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 184.25,
    y1: 1,
    x2: 184.25,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 194.85,
    y1: 1,
    x2: 194.85,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 203.85,
    y1: 1,
    x2: 203.85,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 212.85,
    y1: 1,
    x2: 212.85,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 221.85,
    y1: 1,
    x2: 221.85,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 232.45,
    y1: 1,
    x2: 232.45,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 243.45,
    y1: 1,
    x2: 243.45,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 254.45,
    y1: 1,
    x2: 254.45,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 265.45,
    y1: 1,
    x2: 265.45,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 276.05,
    y1: 1,
    x2: 276.05,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 289.05,
    y1: 1,
    x2: 289.05,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 302.05,
    y1: 1,
    x2: 302.05,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 315.05,
    y1: 1,
    x2: 315.05,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 325.65,
    y1: 1,
    x2: 325.65,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 336.25,
    y1: 1,
    x2: 336.25,
    y2: 194,
    stroke: "white",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_807_46216",
    x1: 172,
    y1: 20.5,
    x2: 172,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0241993,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_807_46216",
    x1: 172,
    y1: 20.5,
    x2: 172,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0241993,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B1E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseScene);
export default __webpack_public_path__ + "static/media/Base-scene.3f6924a5b6a28f0c74e6ce96fda85766.svg";
export { ForwardRef as ReactComponent };